import useTracks from '@/compositions/useTracks';
import { nextTick, ref } from '@vue/composition-api';
import useStreams from '@/compositions/useStreams';
import useSocket from '@/compositions/useSocket';

const cameras = ref([]);

export default function useCamera(onLoadCameras) {
  const {
    replaceTrack, stopTrack,
  } = useTracks();
  const {
    requestMediaStream, setOnEnd, setMyStream, cameraDisabled, getCameras, myCapture,
    setCamera,
  } = useStreams();

  const { sendEvent } = useSocket();

  async function toggleCamera() {
    if (myCapture.value) {
      return;
    }
    if (!cameraDisabled.value) {
      await stopTrack('video');
    } else {
      const mediaStream = await requestMediaStream({
        audio: false,
      });
      if (!mediaStream) {
        return;
      }
      const videoTrack = mediaStream.getTracks().find((t) => t.kind === 'video');
      setOnEnd(videoTrack);
      setMyStream(mediaStream);

      await replaceTrack(videoTrack);

      cameraDisabled.value = false;
      sendEvent('action:video', { state: !cameraDisabled.value });
    }
  }

  async function loadCameras() {
    cameras.value = await getCameras();
  }

  navigator.mediaDevices.addEventListener('devicechange', async () => {
    const oldCamerasLength = cameras.value.length;
    await loadCameras();
    if (typeof onLoadCameras === 'function' && oldCamerasLength !== cameras.value.length) {
      onLoadCameras();
    }
  });

  async function changeCamera(deviceId) {
    if (!deviceId) {
      return;
    }
    localStorage.setItem('camera', deviceId);
    setCamera(deviceId);
    setMyStream(null);
    await nextTick();
    if (!await stopTrack('video')) {
      return;
    }
    const stream = await requestMediaStream({
      audio: false,
    });
    const track = stream.getTracks().find((s) => s.kind === 'video');
    replaceTrack(track);
    cameraDisabled.value = false;
    setMyStream(stream);
  }

  return {
    toggleCamera,
    getCameras,
    cameraDisabled,
    changeCamera,
    loadCameras,
    cameras,
  };
}
